export const makeBidDocumentFileMethods = {
  isImageFile(fileName) {
    const ext = (fileName || '').split('.').pop().toLowerCase()
    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)
  },

  getFileIcon(fileName) {
    const ext = (fileName || '').split('.').pop().toLowerCase()
    const iconMap = {
      pdf: 'el-icon-document',
      doc: 'el-icon-document-copy',
      docx: 'el-icon-document-copy',
      xls: 'el-icon-s-data',
      xlsx: 'el-icon-s-data',
      jpg: 'el-icon-picture-outline',
      jpeg: 'el-icon-picture-outline',
      png: 'el-icon-picture-outline',
      gif: 'el-icon-picture-outline'
    }
    return iconMap[ext] || 'el-icon-document'
  },

  previewPendingFile(file) {
    if (!file || !file.raw) {
      this.$message.warning('文件不存在')
      return
    }
    const url = URL.createObjectURL(file.raw)
    this.previewUrl = url
    this.previewTitle = file.name
    this.previewVisible = true
  },

  closePreview() {
    this.previewVisible = false
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl)
      this.previewUrl = ''
    }
  },

  handleAttFileChange(file, fileList) {
    // 浅拷贝一份新数组，防止 el-upload 销毁时清空内部 uploadFiles 数组导致 pendingAttFiles 也被清空
    this.pendingAttFiles = fileList.map(f => ({ ...f, raw: f.raw }))
    this.$message.success(`已选择 ${fileList.length} 个附件文件，点击保存后上传`)
  },

  removePendingAtt(index) {
    this.pendingAttFiles.splice(index, 1)
    if (this.$refs.attUploader) {
      this.$refs.attUploader.uploadFiles.splice(index, 1)
    }
  },

  handleSignFileChange(file, fileList) {
    this.pendingSignFiles = fileList
    this.$message.success(`已选择 ${fileList.length} 个签章文件，点击保存后上传`)
  },

  removePendingSign(index) {
    this.pendingSignFiles.splice(index, 1)
    if (this.$refs.signUploader) {
      this.$refs.signUploader.uploadFiles.splice(index, 1)
    }
  },

  handleMainFileChange(file, fileList) {
    this.pendingMainFile = fileList[0] || null
    if (this.pendingMainFile) {
      if (this.previewMainUrl) {
        URL.revokeObjectURL(this.previewMainUrl)
      }
      this.previewMainUrl = URL.createObjectURL(this.pendingMainFile.raw)
      this.$message.success('已选择正文文件，点击保存后上传')
    }
  },

  handleMainReupload(file, fileList) {
    this.signedMainBase64 = ''
    if (this.signedMainBlobUrl) {
      URL.revokeObjectURL(this.signedMainBlobUrl)
      this.signedMainBlobUrl = ''
    }
    if (this.previewMainUrl) {
      URL.revokeObjectURL(this.previewMainUrl)
      this.previewMainUrl = ''
    }
    this.pendingMainFile = fileList[0] || null
    if (this.pendingMainFile) {
      this.previewMainUrl = URL.createObjectURL(this.pendingMainFile.raw)
      this.$message.success('已选择新文件，将覆盖之前的文件')
    }
  },

  removePendingMain() {
    this.pendingMainFile = null
    if (this.previewMainUrl) {
      URL.revokeObjectURL(this.previewMainUrl)
      this.previewMainUrl = ''
    }
    if (this.$refs.mainUploader) {
      this.$refs.mainUploader.uploadFiles = []
    }
  },

  handleMainFileRemove() {
    this.pendingMainFile = null
    if (this.previewMainUrl) {
      URL.revokeObjectURL(this.previewMainUrl)
      this.previewMainUrl = ''
    }
  },

  async handleGoSign() {
    // 保存CA状态和开标一览表数据到sessionStorage，签章返回后恢复
    this.savePageStateBeforeSign()

    if (this.signedMainBase64) {
      sessionStorage.setItem('pdfSignBase64', this.signedMainBase64)
      this.$router.push({
        path: '/sign/pdf',
        query: { sectionCode: this.projectInfo.sectionCode, source: 'cache' }
      })
      return
    }
    if (this.pendingMainFile && this.pendingMainFile.raw) {
      const loading = this.$loading({ text: '正在准备签章文件...' })
      try {
        const base64 = await this.fileToBase64(this.pendingMainFile.raw)
        sessionStorage.setItem('pdfSignBase64', base64)
        loading.close()
        this.$router.push({
          path: '/sign/pdf',
          query: { sectionCode: this.projectInfo.sectionCode, source: 'cache' }
        })
      } catch (e) {
        loading.close()
        this.$message.error('文件读取失败：' + e.message)
      }
      return
    }
    // 已保存的正文（从服务器加载的）
    if (this.bidMainUrl) {
      const loading = this.$loading({ text: '正在准备签章文件...' })
      try {
        // 获取PDF内容并转为base64
        const response = await fetch(this.bidMainUrl)
        const blob = await response.blob()
        const base64 = await this.blobToBase64(blob)
        sessionStorage.setItem('pdfSignBase64', base64)
        loading.close()
        this.$router.push({
          path: '/sign/pdf',
          query: { sectionCode: this.projectInfo.sectionCode, source: 'cache' }
        })
      } catch (e) {
        loading.close()
        this.$message.error('文件读取失败：' + e.message)
      }
      return
    }
    this.$message.warning('请重新上传投标正文文件')
  },

  // Blob转Base64辅助方法
  blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        const base64 = reader.result.split(',')[1]
        resolve(base64)
      }
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
  },

  // 签章前保存页面状态
  savePageStateBeforeSign() {
    const state = {
      caLoggedIn: this.caLoggedIn,
      caForm: this.caForm,
      currentCaUserName: this.currentCaUserName,
      certList: this.certList,
      symKey: this.symKey,
      bidKeyInfo: this.bidKeyInfo,
      openingSummaryList: this.openingSummaryList,
      pendingAttFiles: this.pendingAttFiles,
      activeMenu: this.activeMenu,
      // 签章后的正文状态
      signedMainBase64: this.signedMainBase64,
      signedMainBlobUrl: this.signedMainBlobUrl
    }
    sessionStorage.setItem('makeBidDocumentState', JSON.stringify(state))
    console.log('签章前页面状态已保存')
  },

  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        const base64 = reader.result.split(',')[1]
        resolve(base64)
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  },

  checkSignedPdf() {
    const signedBase64 = sessionStorage.getItem('pdfSignedBase64')
    if (signedBase64 && signedBase64.trim()) {
      this.signedMainBase64 = signedBase64
      try {
        const byteChars = atob(signedBase64)
        const byteNumbers = new Array(byteChars.length)
        for (let i = 0; i < byteChars.length; i++) {
          byteNumbers[i] = byteChars.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        if (this.signedMainBlobUrl) {
          URL.revokeObjectURL(this.signedMainBlobUrl)
        }
        this.signedMainBlobUrl = URL.createObjectURL(blob)
      } catch (e) {
        console.error('签章PDF解析失败', e)
      }
      this.pendingMainFile = null
      if (this.previewMainUrl) {
        URL.revokeObjectURL(this.previewMainUrl)
        this.previewMainUrl = ''
      }
      sessionStorage.removeItem('pdfSignedBase64')
      this.activeMenu = '4-1'
      this.$message.success('签章文件已更新')
    }
  }
}
